import React from "react";
import { useOutletContext } from "react-router-dom";
import Faq from "../components/Faq";

export default function FaqPage() {
  const { content, isRtl, text } = useOutletContext();

  return (
    <Faq
      isRtl={isRtl}
      faqheading={text.Arabicfaq}
      faqContent={content.faq || ""}
    />
  );
}
